export default __webpack_public_path__ + "static/synchronized-calendar-6ce10484aa2f0ff2afa95db0f8bfb58b.webp";